import { Shimmer } from '@wartek-id/shimmer'

import { PENGELOLAAN_KINERJA_ASN_SWASTA_PPK_PATH } from 'app/KinerjaShared/constants/path'
import CardPenilaianPeriodik from 'app/KinerjaShared/components/CardPenilaianPeriodik'
import useToggleSdkContext from 'utils/useToogleSdk'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useApiGetPenilaianPeriodikTypePS } from 'api/kinerja/pengawas-sekolah/penilaian-periodik'

export function PeriodikPejabatPenilaiKinerjaCard() {
  const { periodYear } = usePeriodContext()

  // ------------------
  // Resolve toggle value
  // ------------------
  const toggleValue = useToggleSdkContext()
  const isPeriodikAsnSwastaEnabled =
    toggleValue?.['kinerja-asn-swasta-periodik-enabled']

  // ------------------
  // Get penilaian periodik flag
  // ------------------
  const {
    data: periodikTypeData,
    isSuccess: isPeriodikTypeSuccess,
    isLoading: isPeriodikTypeLoading,
  } = useApiGetPenilaianPeriodikTypePS({
    params: { skpYear: periodYear },
    options: {
      enabled: isPeriodikAsnSwastaEnabled,
      staleTime: 60 * 60 * 1000, // 1 hour
      cacheTime: 60 * 60 * 1000, // 1 hour
    },
  })

  const periodikType = periodikTypeData?.data?.periodicType
  const hasPenilaianPeriodik =
    isPeriodikAsnSwastaEnabled &&
    isPeriodikTypeSuccess &&
    periodikType !== 'NOT_FOUND'

  if (isPeriodikTypeLoading) {
    return <Shimmer className="!h-36 !w-full block rounded-lg" />
  }

  if (!hasPenilaianPeriodik) {
    return null
  }

  return (
    <CardPenilaianPeriodik
      ctaText="Lakukan Penilaian"
      href={`${PENGELOLAAN_KINERJA_ASN_SWASTA_PPK_PATH}/periodik`}
      periodicType={periodikType}
    />
  )
}
